import React from 'react';
import TodaysFocus from '../Hub/TodaysFocus';

/**
 * Widget wrapper for TodaysFocus
 * Shows top priority tasks for the day
 */
export default function TodaysFocusWidget({ tasks, onNavigate }) {
  return (
    <TodaysFocus
      tasks={tasks}
      onNavigate={onNavigate}
    />
  );
}
